/**
 * Custom next/image loader for static export (cPanel — no /_next/image).
 * Maps requested widths onto pre-generated variants from
 * scripts/generate-responsive-images.cjs:
 *   /path/name-400w.webp  /path/name-640w.webp  /path/name-960w.webp
 *   /path/name.webp (master)
 *
 * Paths without matching on-disk variants fall through to `src` as-is.
 */

const VARIANT_WIDTHS = [400, 640, 960];

export default function staticImageLoader({ src, width }) {
  if (!src || typeof src !== 'string') return src;

  const q = src.indexOf('?');
  const base = q === -1 ? src : src.slice(0, q);
  const query = q === -1 ? '' : src.slice(q);

  // SVG / AVIF — no -Nw variants
  if (/\.(svg|avif)$/i.test(base)) return `${base}${query}`;

  const extMatch = base.match(/\.[a-z0-9]+$/i);
  if (!extMatch) return `${base}${query}`;

  const ext = extMatch[0];
  const stem = base.slice(0, -ext.length);

  // Already a variant URL — leave alone
  if (/-\d+w$/i.test(stem)) return `${base}${query}`;

  const w = typeof width === 'number' ? width : parseInt(width, 10) || VARIANT_WIDTHS[VARIANT_WIDTHS.length - 1];
  const chosen =
    VARIANT_WIDTHS.find((vw) => w <= vw) ?? VARIANT_WIDTHS[VARIANT_WIDTHS.length - 1];

  // Master is capped at 960 by optimize:images — use it for the top bucket
  if (chosen === VARIANT_WIDTHS[VARIANT_WIDTHS.length - 1] && w >= chosen) {
    return `${base}${query}`;
  }

  return `${stem}-${chosen}w${ext}${query}`;
}
